import { IData } from "../../contexts/dataContext";
import { IVehicleSearch } from "../../interfaces/VehicleSearch";
import { isUnderTwentyOne } from "../MakeReservation/util";


export class InfoWindowSingleton {
    private static instance: google.maps.InfoWindow;

    private constructor() { }

    public static getInstance(): google.maps.InfoWindow {
        if (!this.instance) {
            this.instance = new google.maps.InfoWindow();
        }

        return this.instance;
    }
}